// @flow
import { combineReducers } from 'redux';
import { BUS_ARRIVALS } from '../components/ReportSidebar/reportConstants';
import * as types from '../types/reports';
import type { ERROR_TYPE } from '../types/common';
import type { REPORT_ACTION_TYPE } from '../types/reports';
import * as common from './common';

export type ReportsState = {
  current: string,
  data: Object,
  errors: { [number]: ERROR_TYPE }
};

const current = (state: string = BUS_ARRIVALS, action: REPORT_ACTION_TYPE): string => {
  switch (action.type) {
    case types.SET_REPORT: {
      if (action.payload && action.payload.key) {
        return action.payload.key;
      }

      return state;
    }
    default: {
      return state;
    }
  }
};

const data = (state: Object = {}, action: REPORT_ACTION_TYPE): Object => {
  switch (action.type) {
    case types.REPORT_FETCH_SUCCEEDED: {
      if (action.payload) {
        return action.payload;
      }
      break;
    }
    case types.SET_REPORT: {
      return {};
    }
    case types.START_FETCHING_REPORT: {
      return {};
    }
    default: {
      return state;
    }
  }
};

const isFetching = common.isFetching({
  started: [
    types.START_FETCHING_REPORT,
  ],
  succeed: [types.REPORT_FETCH_SUCCEEDED],
});

const reports = combineReducers({
  current,
  data,
  isFetching,
});

export default reports;

export const getCurrentReportKey = (state: ReportsState): string => state.current;
export const getReportData = (state: ReportsState): Object => state.data;



// WEBPACK FOOTER //
// ./src/scripts/reducers/reports.js